import { graphqlPost } from "api/graphqlClient";
import { actions as autocompleteActions } from "components/Form/components/Autocomplete/Autocomplete.reducer";
import NotificationService from "components/Notification/Notification.service";
import RestErrorNotification from "components/Notification/RestErrorNotification";
import get from "lodash/get";
import { call, put, takeEvery } from "redux-saga/effects";
import { getRelativeUrl } from "utils/service";

/**
 * Fetch fetchAutocomplete
 * @param  {Object} promise
 * @param {string} id Stat ID
 * @return {Object} response from API
 */
export function* fetchAutocomplete({
    promise,
    resourceName,
    hasNameAsOptionValue,
    params,
    defaultValue,
    overwritePrevValue,
    iri,
    search,
}) {
    try {
        const fetchAPI = yield graphqlPost(params);

        yield put({
            type: autocompleteActions.FETCH_AUTOCOMPLETE_SUCCESSFUL,
        });

        const path = `${resourceName}_list.${resourceName}_list`;
        const countPath = `${resourceName}_list.${resourceName}_count`;

        const options = get(fetchAPI?.data, path, []).map((item) => ({
            value: hasNameAsOptionValue ? item?.name : item?.id,
            label: item?.name,
            link: resourceName ? getRelativeUrl(resourceName, item.id) : null,
            ...item,
        }));

        // add default value to the start of options
        if (defaultValue) {
            options.unshift(defaultValue);
        }

        yield put({
            type: autocompleteActions.STORE_AUTOCOMPLETE_DATA,
            iri,
            response: options,
            overwritePrevValue,
        });
        const count = get(fetchAPI?.data, countPath, 0);
        yield put({
            type: autocompleteActions.STORE_AUTOCOMPLETE_COUNT,
            iri,
            response: count,
        });

        if (search) {
            yield put({
                type: autocompleteActions.STORE_SEARCH_COUNT,
                iri,
                response: count,
            });
        }
        yield call(promise.resolve, options);
    } catch (error) {
        yield put({
            type: autocompleteActions.FETCH_AUTOCOMPLETE_FAILED,
        });
        NotificationService.error(<RestErrorNotification error={error} />);
        yield call(promise.reject, error?.response?.data || error);
    }
}

/**
 * Register action to watcher
 */
export default [takeEvery(autocompleteActions.START_FETCHING_AUTOCOMPLETE, fetchAutocomplete)];
